import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Poster, UpsertPosterInput } from '@nx/domain';

const posterSlice = createSlice({
  name: 'poster',
  initialState: {
    current: null as Poster | null,
    loading: false,
    saving: false,
    error: null as string | null,
  },
  reducers: {
    posterLoadRequested(_state, _action: PayloadAction<string>) {
      _state.loading = true;
    },
    posterLoaded(state, action: PayloadAction<Poster | null>) {
      state.current = action.payload;
      state.loading = false;
    },
    posterUpsertRequested(
      state,
      _action: PayloadAction<{ eventId: string; input: UpsertPosterInput }>,
    ) {
      state.saving = true;
    },
    posterSaveSucceeded(state, action: PayloadAction<Poster>) {
      state.current = action.payload;
      state.saving = false;
    },
    posterFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.saving = false;
      state.error = action.payload;
    },
  },
});

export const {
  posterLoadRequested,
  posterLoaded,
  posterUpsertRequested,
  posterSaveSucceeded,
  posterFailed,
} = posterSlice.actions;

export default posterSlice.reducer;
